import React from 'react';
import {icon, root} from "./styles";
import {TypographyProps} from "./types";


export const Typography: React.FC<TypographyProps> = ({
    variant = "span",
    children,
    leftIcon,
}) => {
    return <div css={root}>
        {leftIcon && <span css={icon[variant]}>{leftIcon}</span>}
        {React.createElement(variant, {
            style: { margin: 0 }
        }, children)}
    </div>
};